// Rails keys nested errors as "levels[1].fast_parameter.pressure"; Formik field names use
// "levels.1.fast_parameter.pressure"
export const railsFieldErrors = (
  serverErrors: Record<string, string[]>
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(serverErrors).map(([key, messages]) => [
      key.replace(/\[(\d+)\]/g, '.$1'),
      messages.join(', ')
    ])
  )
